document.querySelectorAll('.read-more-btn').forEach( (btn) => {
	btn.addEventListener('click', function () {
		let txtMore = 'Read More'
		let txtLess = 'Read Less'
		let moreContent = this.parentElement.querySelector('.read-more-content');
		this.classList.toggle('active');
		if (this.classList.contains('active')) {
			this.innerHTML = txtLess;
			moreContent.style.display = 'block';
		} else {
			this.innerHTML = txtMore;
			moreContent.style.display = 'none';
		}
	});
});
// ── EVJ: Hide Judge.me badges with 0 reviews or rating < 4 ──────────────────
(function () {
  function shouldHide(badge) {
    var reviews = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
    var rating  = parseFloat(badge.getAttribute('data-average-rating') || '0');
    return reviews === 0 || rating < 4;
  }

  function hideBadge(badge) {
    badge.style.setProperty('display', 'none', 'important');
    var wrapper = badge.closest('.jdgm-widget.jdgm-preview-badge');
    if (wrapper) wrapper.style.setProperty('display', 'none', 'important');
  }

  function filterBadges() {
    document.querySelectorAll('.jdgm-prev-badge').forEach(function (badge) {
      if (shouldHide(badge)) hideBadge(badge);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'style') {
        var el = m.target;
        var inner = el.querySelector('.jdgm-prev-badge');
        if (inner && shouldHide(inner)) hideBadge(inner);
        if (el.classList.contains('jdgm-prev-badge') && shouldHide(el)) hideBadge(el);
      }
    });
  });

  function startObserver() {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      subtree: true,
    });
    filterBadges();
  }

  document.addEventListener('jdgm:all:done', filterBadges);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();

